// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-modal-content {
  background-color: #07405E !important;
}

.ant-modal-title {
  color: white !important;
}

span:has(svg) {
  color: white;
}

.historyMain {
  background-color: #07405E;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  position: fixed;
}
.historyMain .historyContainer {
  height: 85%;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  padding: 10px 0px;
}
@media (min-width: 450px) {
  .historyMain .historyContainer {
    width: 400px;
  }
}
@media only screen and (max-height: 712px) {
  .historyMain .historyContainer {
    height: 100%;
  }
}
.historyMain .historyContainer .historyHeader {
  width: 100%;
  border-bottom: 1px solid #699BB6;
  display: flex;
  flex-direction: column;
  padding: 10px 15px 20px 15px;
}
.historyMain .historyContainer .historyHeader .profitBlock {
  display: flex;
  flex-direction: column;
}
.historyMain .historyContainer .historyHeader .profitBlock h2 {
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-transform: uppercase;
  margin: 0;
  padding: 0;
}
.historyMain .historyContainer .historyHeader .profitBlock p {
  color: #699BB6;
  font-family: "Bitter", serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0;
  padding: 0;
}
.historyMain .historyContainer .historyHeader .balanceRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  width: 100%;
}
.historyMain .historyContainer .historyHeader .balanceRow .balanceBlock {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}
.historyMain .historyContainer .historyHeader .balanceRow .balanceBlock h2 {
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  text-transform: uppercase;
  margin: 0;
  padding: 0;
}
.historyMain .historyContainer .historyHeader .balanceRow .balanceBlock p {
  color: #FFFFFF;
  font-family: "Bitter", serif;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  padding: 0;
}
.historyMain .historyContainer .historyHeader .balanceRow .buttonsBlock {
  display: flex;
  flex-direction: column;
}
.historyMain .historyContainer .historyHeader .balanceRow .buttonsBlock .withdrawBtn {
  height: 38px;
  border-radius: 8px;
  border: 0.8px solid #699BB6;
  background: rgba(255, 255, 255, 0);
  padding: 0px 22px;
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  margin-top: 22px;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 155%;
}
.historyMain .historyContainer .historyHeader .dollarSign {
  color: #699BB6;
  font-family: "Bitter", serif;
  font-size: 21px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.historyMain .historyContainer .historyContent {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  padding: 24px 0px;
}
.historyMain .historyContainer .historyContent .noHistoryText {
  color: #FFFFFF;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
  padding: 0;
  text-align: center;
}
.historyMain .historyContainer .historyContent .endListText {
  color: #699BB6;
  font-family: "Bitter", serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0;
  padding: 0;
  margin-top: 20px;
}
.historyMain .historyContainer .historyContent::-webkit-scrollbar {
  width: 8px;
}
.historyMain .historyContainer .historyContent::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
}
.historyMain .historyContainer .historyContent::-webkit-scrollbar-track {
  background-color: transparent;
}
.historyMain .historyContainer .historyContent::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}`, "",{"version":3,"sources":["webpack://./src/modules/history/index.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/fonts.scss"],"names":[],"mappings":"AAGA;EACI,oCAAA;AADJ;;AAGA;EACI,uBAAA;AAAJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AACJ;AAAI;EAII,WAAA;EAIA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AAJR;AARQ;EADJ;IAEQ,YAAA;EAWV;AACF;AATQ;EALJ;IAMQ,YAAA;EAYV;AACF;AAJQ;EACI,WAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;AAMZ;AAJY;EACI,aAAA;EACA,sBAAA;AAMhB;AALgB;EACI,cC9CH;ED+CG,iCE3CX;EF4CW,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;AAOpB;AAJgB;EACI,cC1DH;ED2DG,4BE3DX;EF4DW,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;AAMpB;AAHY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;AAKhB;AAJgB;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;AAMpB;AAJoB;EACI,cChFP;EDiFO,iCE7Ef;EF8Ee,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;AAMxB;AAHoB;EACI,cC5FX;ED6FW,4BE5Ff;EF6Fe,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;AAKxB;AADgB;EACI,aAAA;EACA,sBAAA;AAGpB;AADoB;EACI,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,kCAAA;EACA,iBAAA;EACA,cChHP;EDiHO,iCE7Gf;EF8Ge,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAGxB;AAEY;EACI,cC5HC;ED6HD,4BE7HP;EF8HO,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAAhB;AAGQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,iBAAA;AAFZ;AAGY;EACI,cC9IH;ED+IG,iCE1IP;EF2IO,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AADhB;AAGY;EACI,cCxJC;EDyJD,4BEzJP;EF0JO,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AADhB;AAIQ;EACI,UAAA;AAFZ;AAKU;EACE,sBAAA;EACA,mBAAA;AAHZ;AAMU;EACE,6BAAA;AAJZ;AAOU;EACE,sBAAA;AALZ","sourcesContent":["@import \"../../scss/fonts.scss\";\n@import \"../../scss/colors.scss\";\n\n.ant-modal-content {\n    background-color: #07405E !important;\n  }\n.ant-modal-title {\n    color: white !important;\n}\nspan:has(svg){\n    color: white;\n}\n\n.historyMain {\n    background-color: #07405E;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    height: 100dvh;\n    position: fixed;\n    .historyContainer{\n        @media (min-width: 450px){\n            width: 400px;\n        }\n        height: 85%;\n        @media only screen and (max-height: 712px) {\n            height: 100%;\n        }\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        width: 100%;\n        height: 100dvh;\n        padding: 10px 0px;\n\n        .historyHeader {\n            width: 100%;\n            border-bottom: 1px solid $color-Secondary;\n            display: flex;\n            flex-direction: column;\n            padding: 10px 15px 20px 15px;\n    \n            .profitBlock{\n                display: flex;\n                flex-direction: column;\n                h2{\n                    color: $color-Secondary;\n                    font-family: $Roboto;\n                    font-size: 14px;\n                    font-style: normal;\n                    font-weight: 400;\n                    line-height: 18px; \n                    text-transform: uppercase;\n                    margin: 0;\n                    padding: 0;\n    \n                }\n                p{\n                    color: $color-Secondary;\n                    font-family: $Bitter;\n                    font-size: 24px;\n                    font-style: normal;\n                    font-weight: 600;\n                    line-height: normal;\n                    margin: 0;\n                    padding: 0;\n                }\n            }\n            .balanceRow{\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                margin: 0 auto;\n                width: 100%;\n                .balanceBlock{\n                    margin-top: 10px;\n                    display: flex;\n                    flex-direction: column;\n        \n                    h2{\n                        color: $color-Secondary;\n                        font-family: $Roboto;\n                        font-size: 14px;\n                        font-style: normal;\n                        font-weight: 400;\n                        text-transform: uppercase;\n                        margin: 0;\n                        padding: 0;\n        \n                    }\n                    p{\n                        color: $color-White;\n                        font-family: $Bitter;\n                        font-size: 36px;\n                        font-style: normal;\n                        font-weight: 700;\n                        line-height: normal;\n                        margin: 0;\n                        padding: 0;\n                    }\n                }\n             \n                .buttonsBlock{\n                    display: flex;\n                    flex-direction: column;\n                    \n                    .withdrawBtn {\n                        height: 38px;\n                        border-radius: 8px;\n                        border: 0.8px solid $color-Secondary;\n                        background: rgba(255, 255, 255, 0.00);\n                        padding: 0px 22px;\n                        color: $color-Secondary;\n                        font-family: $Roboto;\n                        margin-top: 22px;\n                        font-size: 16px;\n                        font-style: normal;\n                        font-weight: 700;\n                        line-height: 155%;\n                    }\n                }\n               \n            }\n            .dollarSign{\n                color: $color-Secondary;\n                font-family: $Bitter;\n                font-size: 21px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: normal\n            }\n        }\n        .historyContent{\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            overflow-y: auto;     \n           \n            padding: 24px 0px ;\n            .noHistoryText{\n                color: $color-White;\n                font-family: $Roboto;\n                font-size: 16px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: normal;\n                margin: 0;\n                padding: 0;\n                text-align: center;\n            }\n            .endListText{\n                color: $color-Secondary;\n                font-family: $Bitter;\n                font-size: 12px;\n                font-style: normal;\n                font-weight: 600;\n                line-height: normal;\n                margin: 0;\n                padding: 0;\n                margin-top: 20px;\n            }\n        }\n        .historyContent::-webkit-scrollbar {\n            width: 8px;\n          }\n          \n          .historyContent::-webkit-scrollbar-thumb {\n            background-color: #888;\n            border-radius: 10px;\n          }\n          \n          .historyContent::-webkit-scrollbar-track {\n            background-color: transparent;\n          }\n          \n          .historyContent::-webkit-scrollbar-thumb:hover {\n            background-color: #555;\n          }  \n    }\n}\n\n\n","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
